/*
Sohel 11/28/2022 3031450488  search table Payload changes
Ashraf 11/29/2022 2698947782 fixed download repo data issues
Ashraf 11/29/2022 2698947782 fixed table alignments
Ashraf 11/29/2022 2698947782 disabled edit and delete for system repo's
Poornima 12/01/2022 2698947782 fixed usage popup bug
Prakash 12/01/2022 2698947782 fixed Table word wrap issues.
Poornima 12/01/2022 2698947782 fixed usage component issue
lalitha 12/07/2022 2698947782 added Created By payload
Poornima 12/07/2022 2698947782 delete popup text changes
Ashraf 12/08/2022 2698947782 add notes at search level
akhila 12/08/2022 2698947782 adding session storage for search items
kavya9reddy 12/09/2022 2698947782 Added createdDate in  payload
Poornima 12/12/2022 2698947782 download configuration payload issue fixed
Raghu 12/26/2022 2698947782 Added Dialog Component
Ashraf 01/02/2022 2698947782 renamed usage header title
saikrishna 01/04/2023 2698947782  add createdby and created date to payload
Lalitha 01/04/2023 2698947782 Added createdDate and createdBy in PayLoad
Sohel 01/11/2023 2698947782 Added conditionally Delete Popup
Sohel 01/31/2023 2698947782 Added fixed delete popup issue
kavyareddy 02/07/2023 2698947782 payload change for createdBy
suresh peddavoora 02/21/2023 2698947782 table and textfields alignments
Ravi 02//23/2023 2698947782 Added popup in download configuration button.
Fahaduddin 02/28/2023 2698947782 fixed sorting issues.
Akhila 03/01/2023 2698947782 Added loader and download toast message for preview File
T Santosh Kumar 15/03/2023 2698947782 Responsive UI Changes
Raghu 03/16/2023 2698947782 action table fixes
Raghu 03/04/2023 2698947782 added plus icon
Prakash 10/04/2023 2698947782 fixed table issue
Ravi 05/31/2023 2698947782 changed delete popup message
Akhila 06/07/2023 2698947782 added code and description in action
Akhila 06/08/2023 2698947782 created date change to date created field and column
sohel 09/24/2023 5155351299 payload modification new fields added
Sohel 09/26/2023 5155351299 Company lookup data change and integerated
Sohel 10/01/2023 5155351299 Removed Company Field
uday 10/02/2023 5155351299 add scroll for table
Sohel 10/04/2023 5155351299 download configuration payload changes
Sohel 06/10/2023 5155351299 download configuration usage payload added
Sohel 12/02/2023 5155351299 Added New Search Field
Sohel 12/10/2023 5155351299 bug fixed reset issue when extra space searching
*/

import { Button, Grid, TablePagination } from '@material-ui/core';
// import MaterialTable from "material-table";
import React, { createRef, useEffect, useState, useContext, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { tableIcons } from '../../../../../components/TableIcons';
import { defaultRows } from '../../../../../constants/ReusableTablePagination';
import {
  fetchDataRepository,
  printDataRepositories,
  resetDataRepo,
  fetchDataRepoUsage,
  resetConfigUrl,
  resetDockey,
} from '../../../../../redux/reducers/GlobalField/DataRepository';
import { httpPaginationDelete, httpPaginationPost } from '../../../../../util/Rest';
import { resetMessage } from '../../../../../redux/reducers/GlobalField/AddFieldList';
import { resetMsg } from '../../../../../redux/reducers/GlobalField/DataRepository';
import {
  SuccessSnackbar,
  ErrorSnackbar,
  WarningSnackbar,
} from '../../../../../components/CustomSnackBar';
import { postPrintUsage, resetPrintUsageData } from '../../../../../redux/reducers/printUsage';
import DeleteTableRecordPopup from '../../../../../util/DeleteTableRecordPopup';
import { useUpdateEffect } from 'react-use';
import OverrideRule from '../../../../../components/OverrideRule';
import SelectTabContextProvider from '../../../../../components/SelectTabContext/SelectTabContext';
import { makeStyles } from '@material-ui/core';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import { tablePageRows } from '../../../../../constants/ReusableConstants';
import UsageMessage from '../../../../../util/UsageMessage';
import { getFields } from '../../../Reports/AddReport/Components/utils';
import moment from 'moment';
import RepoNotes from './RepoNotes';
import { DATA_REPOSITORY } from '../../../../../constants/ReusableRoleAccess';
import DialogBox from '../../../../../components/DialogBox';
import { downloadButton } from '../../../../../util/Content';
import DataExistsPopup from './DataExistsPopup';
import PreviewFileDialog from '../../../../../util/PreviewFileDialog';
import axios from 'axios';
import PageLoader from '../../../../../components/PageLoader';
import { resetDownloadMsg } from '../../../../../redux/reducers/PreviewFileData';
import SaveIcon from '@material-ui/icons/Save';
import ActionMenuItem from '../../../../../util/ActionMenuItem';
import { MTableToolbar } from 'material-table';
import AddIcon from '@material-ui/icons/AddOutlined';

const FieldListSearchTable = ({
  searchData,
  setTabValue,
  submit,
  setSubmit,
  setFieldListRowData,
  setUsage,
  usage,
  isDelete,
  setIsDelete,
  userMetrixDelete,
  setUsageState,
  usageState,
  setRowSelected,
  setUserMetrixDelete,
  setIsCopyData,
  StepperFieldList,
  setShowSearch,
  setFieldListCode,
  setFieldList,
  fieldList,
  isReportLoader,
  deleteSql,
  isReports,
  isReportsFilter,
  rules,
  setRules,
  sortFields,
  setSortFields,
  selectedRows,
  setFieldValue,
  setSelectedRows,
}) => {
  const tableRef = createRef();
  const dispatch = useDispatch();
  const [arrayLast, setArrayLast] = useState(false);
  const [rows, setRows] = useState(defaultRows);
  const [deleteData, setDeleteData] = useState({});
  const [tstmsg, setToastMsg] = useState('');
  const [status, setStatus] = useState(false);
  const [dataCount, setDataCount] = useState('');
  const [deleteErrorMsg, setDeleteErrorMsg] = useState('');
  const { setGlobalFieldRow } = useContext(SelectTabContextProvider);
  const printusage = useSelector(({ printusage }) => printusage);
  const { roleData } = useSelector(({ role }) => role);
  const dataRepoAccess = roleData?.window?.[DATA_REPOSITORY]?.['DR'];
  // const [order, setOrder] = useState({});
  const order = {};
  const [customError, setCustomError] = useState(false);
  const [deleteUsage, setDeleteUsage] = useState(false);
  const [isNote, setIsNote] = useState(false);
  const [triggerData, setTriggerData] = useState();
  const [isDataExists, setISDataExists] = useState(false);
  const [configOpen, setConfigOpen] = useState(false);
  const [isLoadingPrint, setIsLoadingPrint] = useState(false);
  const [configData, setConfigData] = useState(null);
  const companyData = JSON.parse(sessionStorage.getItem('companyName'));
  companyData?.unshift('ALL');
  const {
    DataRepoPrintStatus,
    successMsg,
    errorMsg,
    isLoading,
    dataRepoUsage,
    notesuccessMsg,
    configurationUrl,
    dockey,
  } = useSelector(({ dataRepository }) => dataRepository);

  const queryRef = useRef(null);

  const useStyles = makeStyles((theme) => ({
    link: {
      // Changed field list code column font color (2700799562)
      color: '#320469 !important',
      textAlign: 'justify',
      whiteSpace: 'normal',
      wordWrap: 'break-word',
      borderBottom: '1px solid #000099',
    },
    ' & .MuiSvgIcon-root': {
      backgroundColor: '#320469 !important',
    },
  }));
  const classes1 = useStyles();
  const handleCloseDataExists = () => {
    setISDataExists(false);
  };
  useEffect(() => {
    if (configurationUrl) {
      setIsLoadingPrint(true);
      async function readData() {
        setConfigOpen(true);
        const data = await axios({
          url: configurationUrl,
          method: 'GET',
        });
        setConfigData(data);
        setIsLoadingPrint(false);
      }
      readData();
    }
  }, [configurationUrl]);

  useEffect(() => {
    if (dataRepoUsage?.userMetrix === 'No') {
      if (dataRepoUsage?.dataExits === 'Yes' && deleteUsage) {
        setISDataExists(true);
      } else {
        deleteUsage ? setUserMetrixDelete(false) : setCustomError(true);
        deleteUsage && setIsDelete(true);
        setTimeout(() => {
          setCustomError(false);
          dispatch(resetDataRepo());
        }, 2000);
      }
    } else if (dataRepoUsage?.userMetrix === 'Yes') {
      deleteUsage && setIsDelete(true);
      deleteUsage && setUserMetrixDelete(true);
      !deleteUsage && setUsage(true);
      !deleteUsage && setTabValue(2);
    }
  }, [dataRepoUsage]);

  useEffect(() => {
    if (DataRepoPrintStatus === 200 && successMsg) {
      setTimeout(() => {
        dispatch(resetDataRepo());
        setTabValue(0);
      }, 3000);
    }
  }, [DataRepoPrintStatus, successMsg]);

  useEffect(() => {
    if (tableRef?.current && submit) {
      Object.keys(searchData).length > 0 ? tableRef.current.onQueryChange() : '';
    }
  }, [submit]);
  const handleEdit = (rowData) => {
    if (rowData?.dataRepositoryId) {
      dispatch(fetchDataRepository(rowData?.dataRepositoryId));
      setRowSelected(rowData?.dataRepositoryId);
      if (!StepperFieldList) {
        setTabValue(1);
        setGlobalFieldRow(true);
      } else {
        setShowSearch(true);
      }
    }
  };
  // const handleDelete = (rowData) => {
  //   handleDelete(rowData);
  // };
  const handleNotes = (rowData) => {
    setIsNote(true);
    setISDataExists(false);
    setTriggerData(rowData);
  };
  const handleUsage = (rowData) => {
    setDeleteUsage(false);
    setISDataExists(false);
    dispatch(fetchDataRepoUsage(rowData?.dataRepositoryId));
    setFieldListRowData(rowData);
  };

  const handleCloseNotesDialog = () => {
    setIsNote(false);
  };

  // if table data print successfully or error message then reset message after 3sec.(2700799562)
  useEffect(() => {
    if (printusage.errorMsg || printusage.successMsg) {
      setTimeout(() => {
        dispatch(resetPrintUsageData());
      }, 3000);
    }
  }, [printusage.errorMsg, printusage.successMsg]);

  useEffect(() => {
    if (successMsg) {
      tableRef.current.onQueryChange();
    }
  }, [successMsg]);

  // delete data reset error or sucess toast message after 2.5sec(2700799562)
  useEffect(() => {
    if (tstmsg || deleteErrorMsg) {
      setTimeout(() => {
        setToastMsg('');
        setDeleteErrorMsg('');
      }, 2500);
    }
  }, [tstmsg, deleteErrorMsg]);

  // if Usage then reset Usage State(2700799562)
  useEffect(() => {
    usageState && setUsageState(false);
    isDataExists && setISDataExists(false);
    customError && setCustomError(false);
    setUsage(false);
  }, []);

  const handleDelete = (rowData) => {
    setDeleteData(rowData);
    dispatch(fetchDataRepoUsage(rowData?.dataRepositoryId));
    setIsDelete(false);
    setDeleteUsage(true);
    setUsage(false);
    // dispatch(deleteRepository(rowData?.dataRepositoryId));
    // setIsDelete(true);
    // setDeleteUsage(true);
  };

  const handleCloseDialog = () => {
    setIsDelete(false);
    setTimeout(() => {
      setUserMetrixDelete(false);
    }, 1000);
  };

  // status is changed Update Table Data(2700799562)
  useUpdateEffect(() => {
    if (status === true) {
      tableRef.current.onQueryChange();
      setStatus(false);
    }
  }, [status]);

  // delete Global Field List(2700799562)
  const handleSubmit = () => {
    setStatus(true);
    httpPaginationDelete(`data-repository/delete/data-repository/${deleteData?.dataRepositoryId}`)
      .then((response) => {
        if (response?.status === 200 && response?.data?.status !== 400) {
          setToastMsg(response?.response);
          setStatus(false);
          // dispatch(fetchSuccess(response));
          handleCloseDialog();
          setTimeout(() => {
            dispatch(resetMessage());
          }, 6000);
        } else {
          setDeleteErrorMsg(response?.data?.message);
          setStatus(false);
          handleCloseDialog();
          setTimeout(() => {
            dispatch(resetMessage());
          }, 6000);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handleConfigClose = () => {
    setConfigOpen(false);
    dispatch(resetConfigUrl());
    dispatch(resetDockey());
    dispatch(resetDownloadMsg());
  };

  // checking when delete there is usage or not(2700799562)
  const handleDeleteUsage = () => {
    if (isDelete && userMetrixDelete) {
      // setFieldListRowData(deleteData);
      setUsage(true);
      setIsDelete(false);
      setTimeout(() => {
        setUserMetrixDelete(false);
      }, 1000);

      // setTabValue(2);
    } else {
      handleSubmit();
    }
  };
  const columns = [
    {
      title: 'Category',
      field: 'category',
      maxWidth: 85,
      render: (rowData) => {
        return rowData?.category === 'CL'
          ? 'CL - Client'
          : rowData?.category === 'CO'
            ? 'CO - Core'
            : rowData?.category === 'PA'
              ? 'PA - Payment'
              : '';
      },
    },

    {
      title: 'Repository Name',
      field: 'repositoryName',
      cellStyle: {
        maxWidth: 250,
        minWidth: 250,
      },
      render: (rowData) => (
        <span
          className={` ${classes1.link}`}
          role="button"
          onClick={() => {
            if (rowData?.dataRepositoryId) {
              dispatch(fetchDataRepository(rowData?.dataRepositoryId));
              setRowSelected(rowData?.dataRepositoryId);
              if (!StepperFieldList) {
                setTabValue(1);
                setGlobalFieldRow(true);
              } else {
                setShowSearch(true);
              }
            }
          }}
        >
          {rowData?.repositoryName?.replace(/ /g, '\u00a0')}
        </span>
      ),
    },
    {
      title: 'Repository Description',
      field: 'repositoryDescription',
      maxWidth: 200,
      render: (rowData) => (
        <>
          <div
            style={{
              maxWidth: 200,
              // textAlign: "justify",
              whiteSpace: 'normal',
              wordWrap: 'break-word',
            }}
          >
            {rowData.repositoryDescription.replace(/ /g, '\u00a0')}
          </div>
        </>
      ),
    },
    {
      title: 'Repository Type',
      field: 'repositoryType',
    },
    {
      title: 'Table/Repository',
      field: 'tableName',
    },
    {
      title: 'Multi Record',
      field: 'multiRecord',
      render: (rowData) => {
        return rowData?.multiRecord === 'Y' ? 'Yes' : rowData?.multiRecord === 'N' ? 'No' : '';
      },
    },
    {
      title: 'Created By',
      field: 'createdBy',
      maxWidth: 100,
    },
    {
      title: 'Date Created',
      field: 'createdDate',
      maxWidth: 90,
      render: (rowData) => {
        return rowData?.createdDate ? moment(rowData?.createdDate).format('MM/DD/YYYY') : '';
      },
    },
  ];

  return (
    <>
      {isLoading || (
        <DeleteTableRecordPopup
          open={isDelete}
          dialogClose={handleCloseDialog}
          title="Delete Data Repository"
          value={
            userMetrixDelete ? (
              <UsageMessage value={'Data Repository'} />
            ) : (
              `Are you sure you want to delete the ${deleteData?.repositoryName} Data Repository ?`
            )
          }
          handleSubmit={handleDeleteUsage}
          buttonCondition={userMetrixDelete}
        />
      )}
      <OverrideRule
        dialogTitle="Data Repository Usage"
        dialogOpen={usage}
        dialogClose={() => setUsage((state) => !state)}
        title={`This Data Repository has been used in the following places.`}
        data={dataRepoUsage?.placeResponse}
        isOverRide={false}
        type={'Data Repository'}
      />
      <PreviewFileDialog
        open={configOpen}
        dialogClose={handleConfigClose}
        fileUrl={configurationUrl}
        configData={configData}
        dockey={dockey}
        moduleName={'Data Repository'}
      />
      <DialogBox
        open={isNote}
        dialogClose={handleCloseNotesDialog}
        title="Data Repository Notes"
        maxWidth="lg"
      >
        <RepoNotes triggerData={triggerData} />
      </DialogBox>
      <DialogBox
        open={isDataExists}
        dialogClose={handleCloseDataExists}
        title="Delete Data Repository"
        maxWidth="sm"
      >
        <DataExistsPopup setISDataExists={setISDataExists} deleteData={deleteData} />
      </DialogBox>
      <Grid item xs={12}>
        <div className="custom-table  custom-toolbar-icons custom-actions-icon  global-field-table new-standard-textfields actions-dropdown-table tablescroll-block">
          <GuiTable
            title={''}
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            onSelectionChange={(rows, row) => {
              if (row?.tableData?.checked) {
                if (setSelectedRows) {
                  setSelectedRows([
                    ...selectedRows,
                    {
                      ...row,
                      tableData: { ...row.tableData, id: row.fieldName },
                      ...(!isReportsFilter && getFields(row)),
                    },
                  ]);
                  // setFieldValue("fieldHeader" + row.fieldName, row.fieldLabel);
                  // setFieldValue("printSubTotal" + row.fieldName, "N");
                }
                if (setRules) {
                  if (row?.tableData?.checked) {
                    const obj = {
                      field: { ...row, dataType: row.fieldType, globalField: row.fieldName },
                      condition: '',
                      value: '',
                      sqlValue: '',
                      value1: '',
                      ruleCode: '',
                      ...row,
                    };
                    const copyArr = [...rules];
                    obj.ruleCode =
                      copyArr.length > 0
                        ? 'S' + (Number(copyArr[copyArr.length - 1].ruleCode.slice(1)) + 1)
                        : 'S1';
                    copyArr.push(obj);
                    setRules(copyArr);
                    // setSelectedRows(rows);
                  }
                }
                if (setSortFields) {
                  const dataObj = {
                    seqNum: '',
                    sortOrder: 'N',
                    printTotal: 'N',
                  };
                  setSortFields([
                    ...sortFields,
                    {
                      ...row,
                      tableData: { ...row.tableData, id: row.fieldName },
                      ...dataObj,
                    },
                  ]);
                }
              } else {
                if (setSelectedRows) {
                  const updatedRows = [...selectedRows]
                    .filter((ele) => ele?.fieldName !== row?.fieldName)
                    .map((ele) => {
                      return { ...ele, tableData: { ...ele.tableData, id: ele.fieldName } };
                    });
                  setSelectedRows(updatedRows);
                }

                if (setSortFields) {
                  const updatedRows = [...sortFields]
                    .filter((ele) => ele?.fieldName !== row?.fieldName)
                    .map((ele) => {
                      return { ...ele, tableData: { ...ele.tableData, id: ele.fieldName } };
                    });
                  setSortFields(updatedRows);
                }
              }
            }}
            isLoading={isLoading || isReportLoader || printusage?.isLoading}
            data={(query) =>
              new Promise((resolve) => {
                const url = `data-repository/searchall/data-repository`;
                const SearchSessionData = JSON.parse(sessionStorage.getItem('DataRepository'));
                if (SearchSessionData && !submit) {
                  searchData = SearchSessionData;
                }
                const bodyObj = {
                  category: searchData?.category?.categoryCode
                    ? searchData.category?.categoryCode
                    : '',
                  repositoryName: searchData?.repoName ? searchData.repoName : '',
                  repositoryDescription: searchData?.repoDescription
                    ? searchData.repoDescription
                    : '',
                  repositoryType: searchData?.repositoryType?.value
                    ? searchData?.repositoryType?.value
                    : '',
                  tableName: searchData?.tableName ? searchData?.tableName : '',
                  multiRecord: searchData?.multiRecord?.value ? searchData?.multiRecord?.value : '',
                  company: companyData.length > 0 ? companyData : [],
                  limit: query.pageSize ? query.pageSize : null,
                  orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                  orderDirection: query?.orderDirection ? query?.orderDirection : '',
                  createdBy: searchData?.createdBy?.userLoginName
                    ? searchData?.createdBy?.userLoginName
                    : '',
                  createdDate: searchData?.createdDate
                    ? moment(searchData?.createdDate).format('MM/DD/YYYY')
                    : '',
                  page: submit
                    ? 1
                    : arrayLast && query.page >= 1
                      ? query.page
                      : arrayLast
                        ? (query.page <= 1 && query.page + 1) || query.page - 1
                        : query.page + 1,
                };
                queryRef.current = query;
                if (!searchData) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      setSubmit(false);
                      if (response?.status === 200) {
                        const data = response.data.response.resultObject;
                        const newObj = {};
                        if (selectedRows) {
                          selectedRows.forEach((el) => {
                            if (!newObj[el.fieldName]) {
                              newObj[el.fieldName] = el;
                            }
                          });
                        }
                        if (sortFields) {
                          sortFields.forEach((el) => {
                            if (!newObj[el.fieldName]) {
                              newObj[el.fieldName] = el;
                            }
                          });
                        }

                        const newRows = data?.map((elem) => {
                          if (newObj[elem.fieldName]) {
                            return { ...elem, tableData: { ...elem.tableData, checked: true } };
                          } else {
                            return {
                              ...elem,
                              tableData: { ...elem.tableData, checked: false },
                            };
                          }
                        });
                        resolve({
                          data:
                            isReports && newRows?.length > 0
                              ? newRows
                              : data.length > 0
                                ? data
                                : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setArrayLast(response.data.response.resultObject.length === 1);
                        setDataCount(response.data.response.count);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            // actions={
            //   !isReports
            //     ? [
            //         {
            //           icon: () => (
            //             <>
            //               <Button
            //                 type="button"
            //                 variant="outlined"
            //                 className={`mx-1 search-btn`}
            //                 disabled={!dataRepoAccess?.add}
            //               >
            //                 Add Data Repository
            //               </Button>
            //             </>
            //           ),
            //           isFreeAction: true,
            //           disabled: !dataRepoAccess?.add,
            //           onClick: (event) => {
            //             dispatch(resetMsg());
            //             if (StepperFieldList) {
            //               setShowSearch(true);
            //             } else {
            //               setTabValue(1);
            //             }
            //           },
            //         },
            //         (rowData) => ({
            //           icon: () => <EditOutlinedIcon />,
            //           tooltip: "Edit",
            //           disabled: rowData?.repositoryType === "SYSTEM" || !dataRepoAccess?.edit,
            //           onClick: (event, rowData) => {
            //             if (rowData?.dataRepositoryId) {
            //               dispatch(fetchDataRepository(rowData?.dataRepositoryId));
            //               setRowSelected(rowData?.dataRepositoryId);
            //               if (!StepperFieldList) {
            //                 setTabValue(1);
            //                 setGlobalFieldRow(true);
            //               } else {
            //                 setShowSearch(true);
            //               }
            //             }
            //           },
            //         }),
            //         // (rowData) => ({
            //         //   icon: () => <FileCopyOutlinedIcon />,
            //         //   tooltip: "Copy",
            //         //   disabled: true,
            //         //   hidden: rowData?.repositoryType === "SYSTEM",
            //         //   onClick: (event, rowData) => {
            //         //     setIsCopyData(true);
            //         //     dispatch(fetchDataRepository(rowData?.dataRepositoryId));
            //         //     setTabValue(1);
            //         //   },
            //         // }),
            //         (rowData) => ({
            //           icon: () => <DataUsageIcon className={classes.copyButtonroot} />,
            //           tooltip: "Usage",
            //           // hidden: rowData?.repositoryType === "SYSTEM",
            //           hidden: isReports,
            //           onClick: (event, rowData) => {
            //             setDeleteUsage(false);
            //             setISDataExists(false);
            //             dispatch(fetchDataRepoUsage(rowData?.repositoryName));
            //             setFieldListRowData(rowData);
            //           },
            //         }),
            //         (rowData) => ({
            //           icon: () => <DeleteOutlineOutlinedIcon />,
            //           tooltip: "Delete",
            //           disabled: rowData?.repositoryType === "SYSTEM" || !dataRepoAccess?.delete,
            //           onClick: (event, rowData) => {
            //             handleDelete(rowData);
            //           },
            //         }),
            //         {
            //           icon: () => <DescriptionOutlinedIcon className={classes.copyButtonroot} />,
            //           tooltip: "Data Repository Notes",
            //           onClick: (event, rowData) => {
            //             setIsNote(true);
            //             setISDataExists(false);
            //             setTriggerData(rowData?.repositoryName);
            //           },
            //         },
            //       ]
            //     : []
            // }
            options={{
              search: false,
              pageSize: rows,
              toolbar: !isReports,
              toolbarButtonAlignment: 'left',
              selection: isReports,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              showTextRowsSelected: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            actions={[
              {
                icon: () => <SaveIcon />,
                tooltip: 'Save User',
                onClick: (event, rowData) => console.log(rowData, 'rowData'),
              },
            ]}
            components={{
              Pagination: (props) => (
                // Added Download Configuration Buttons in Table Pagination (2700799562)
                <div className="global-field-table-footer pagination-block">
                  {/* letter we removed that one */}
                  {isReports && <div className="mt-2"></div>}
                  {!isReports && (
                    <div className="mt-2">
                      <Button
                        type="button"
                        variant="outlined"
                        className={`mx-1 search-btn`}
                        disabled={Boolean(dataCount === 0)}
                        onClick={(event) => {
                          const SearchSessionData = JSON.parse(
                            sessionStorage.getItem('DataRepository'),
                          );
                          if (SearchSessionData && !submit) {
                            searchData = SearchSessionData;
                          }
                          dispatch(
                            postPrintUsage({
                              category: searchData?.category?.categoryCode
                                ? searchData.category?.categoryCode
                                : '',

                              fieldListOrderBy:
                                queryRef.current.orderBy && queryRef.current.orderBy.field
                                  ? queryRef.current.orderBy.field
                                  : '',
                              fieldListOrderDerection: queryRef.current?.orderDirection
                                ? queryRef.current?.orderDirection
                                : '',
                              createdBy: searchData?.createdBy?.userLoginName
                                ? searchData?.createdBy?.userLoginName
                                : '',
                              createdDate: searchData?.createdDate
                                ? moment(searchData?.createdDate).format('MM/DD/YYYY')
                                : '',
                              fieldName: searchData?.fieldName ? searchData.fieldName : '',
                              frameworkUsageOrderBy: order?.orderBy ? order?.orderBy : '',
                              frameworkUsageOrderDerection: order?.orderDirection
                                ? order?.orderDirection
                                : '',
                              repositoryName: searchData?.repoName ? searchData.repoName : '',
                              repositoryDescription: searchData?.repoDescription
                                ? searchData.repoDescription
                                : '',
                              repositoryType: searchData?.repositoryType?.value
                                ? searchData?.repositoryType?.value
                                : '',
                              tableName: searchData?.tableName ? searchData?.tableName : '',
                              multiRecord: searchData?.multiRecord?.value
                                ? searchData?.multiRecord?.value
                                : '',
                              sourceType: 'DATA REPOSITORY',
                              fieldDescription: searchData?.fieldDescription
                                ? searchData.fieldDescription
                                : '',
                              company: companyData.length > 0 ? companyData : [],
                            }),
                          );
                        }}
                      >
                        Download Configuration Usage
                      </Button>
                      <Button
                        type="button"
                        variant="outlined"
                        className={`mx-1 search-btn`}
                        disabled={Boolean(dataCount === 0)}
                        onClick={(event) => {
                          const SearchSessionData = JSON.parse(
                            sessionStorage.getItem('DataRepository'),
                          );
                          if (SearchSessionData && !submit) {
                            searchData = SearchSessionData;
                          }
                          dispatch(
                            printDataRepositories({
                              category: searchData?.category?.categoryCode
                                ? searchData.category?.categoryCode
                                : '',
                              repositoryName: searchData?.repoName ? searchData.repoName : '',
                              repositoryDescription: searchData?.repoDescription
                                ? searchData.repoDescription
                                : '',
                              repositoryType: searchData?.repositoryType?.value
                                ? searchData?.repositoryType?.value
                                : '',
                              tableName: searchData?.tableName ? searchData?.tableName : '',
                              multiRecord: searchData?.multiRecord?.value
                                ? searchData?.multiRecord?.value
                                : '',
                              orderBy:
                                queryRef.current.orderBy && queryRef.current.orderBy.field
                                  ? queryRef.current.orderBy.field
                                  : '',
                              orderDirection: queryRef.current?.orderDirection
                                ? queryRef.current?.orderDirection
                                : '',
                              fieldName: searchData?.fieldName ? searchData.fieldName : '',
                              createdBy: searchData?.createdBy?.userLoginName
                                ? searchData?.createdBy?.userLoginName
                                : '',
                              createdDate: searchData?.createdDate
                                ? moment(searchData?.createdDate).format('MM/DD/YYYY')
                                : '',
                              company: companyData.length > 0 ? companyData : [],
                              printIndividual: 'N',
                              fieldsSearch: 'N',
                              fieldDescription: searchData?.fieldDescription
                                ? searchData.fieldDescription
                                : '',
                            }),
                          );
                        }}
                      >
                        {downloadButton}
                      </Button>
                    </div>
                  )}
                  <div>
                    <TablePagination
                      {...props}
                      SelectProps={{
                        inputProps: { 'aria-label': 'Rows per screen' },
                      }}
                      labelRowsPerPage={'Rows per screen:'}
                      rowsPerPageOptions={tablePageRows}
                      onChangeRowsPerPage={(event) => {
                        props.onChangeRowsPerPage(event);
                        setRows(event.target.value);
                      }}
                    />
                  </div>
                </div>
              ),
              Action: (props) => (
                <ActionMenuItem
                  {...props}
                  handleDelete={handleDelete}
                  handleEdit={handleEdit}
                  handleNotes={handleNotes}
                  handleUsage={handleUsage}
                  hiddenMenu={{
                    edit: props?.data?.repositoryType === 'SYSTEM',
                    run: true,
                    copy: true,
                    hiddenDelete: false,
                    notes: false,
                    execution: true,
                    usage: isReports,
                    user: true,
                    password: true,
                    test: true,
                  }}
                  disableMenu={{
                    disableEdit: props?.data?.repositoryType === 'SYSTEM' || !dataRepoAccess?.edit,
                    disableRun: false,
                    disableCopy: false,
                    disableDelete:
                      props?.data?.repositoryType === 'SYSTEM' || !dataRepoAccess?.delete,
                    disableNotes: false,
                    disableExecution: false,
                    disableUsage: false,
                    disableUser: false,
                    disablePassword: false,
                    disableTest: false,
                  }}
                />
              ),
              Toolbar: (props) => (
                <div>
                  <MTableToolbar {...props} />
                  <div>
                    {/* {mapRecord && ( */}
                    <Button
                      type="button"
                      variant="outlisetOpenned"
                      className={`mx-1 search-btn`}
                      disabled={!dataRepoAccess?.add}
                      isFreeAction={true}
                      onClick={(event) => {
                        dispatch(resetMsg());
                        if (StepperFieldList) {
                          setShowSearch(true);
                        } else {
                          setTabValue(1);
                        }
                      }}
                      startIcon={<AddIcon />}
                    >
                      Add Data Repository
                    </Button>
                    {/* )} */}
                  </div>
                </div>
              ),
            }}
          />
        </div>
        {isLoadingPrint && <PageLoader />}
        {customError && (
          <WarningSnackbar errorMsg={'This Data Repository is not being used anywhere'} />
        )}
        {(errorMsg || deleteErrorMsg || printusage?.errorMsg) && (
          <ErrorSnackbar errorMsg={errorMsg || printusage?.errorMsg || deleteErrorMsg} />
        )}
        {(notesuccessMsg || successMsg || printusage?.successMsg || tstmsg) && (
          <SuccessSnackbar
            successMsg={notesuccessMsg || successMsg || printusage?.successMsg || tstmsg}
          />
        )}
      </Grid>
    </>
  );
};

export default FieldListSearchTable;
